module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q1-lockup.06f67e9d.png";